import * as React from "react";
import { useEffect, useState } from "react";
import Notifications from "../../presentations/Notifications";

const NotificationsContainer = (props: any) => {
  const { onNotificationsChange } = props;

  const data: any = [
    {
      id: 0,
      user: {
        firstName: "Amit",
        lastName: "Chaudhary",
      },
      title: "Time of Request",
      date: new Date(),
      message: "New user added. Please take action or delete this notification",
    },
    {
      id: 2,
      user: {
        firstName: "Amit",
        lastName: "Chaudhary",
      },
      title: "Time of Request",
      date: new Date(),
      message: "New user added",
    },
    {
      id: 3,
      user: {
        firstName: "Amit",
        lastName: "Chaudhary",
      },
      title: "Shift Change",
      date: new Date(),
      message: "New user added",
    },
    {
      id: 4,
      user: {
        firstName: "Amit",
        lastName: "Chaudhary",
      },
      title: "Shift Change",
      date: new Date(),
      message: "New user added",
    },
  ];

  const [notifications, setNotifications] = useState([]);

  const handleOnDismiss = (notificationId: number) => {
    notifications.splice(
      notifications.findIndex((item: any) => item.id === notificationId),
      1
    );
    setNotifications(notifications);

    // Update notifications in header (badge)
    onNotificationsChange(notifications.length);
  };

  useEffect(() => {
    setNotifications(data);
    onNotificationsChange(data?.length);
    console.log('use effect ========');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnDismissAll = () => {
    setNotifications([]);

    // Update notifications in header (badge)
    onNotificationsChange(0);
  };

  return (
    <div className="">
      <Notifications
        data={notifications}
        onDismiss={handleOnDismiss}
        onDismissAll={handleOnDismissAll}
      ></Notifications>
    </div>
  );
};

export default NotificationsContainer;
